var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59988 17.2412H1.72363C1.20613 17.2412 0.786133 16.8212 0.786133 16.3037C0.786133 15.7862 1.20613 15.3662 1.72363 15.3662H9.59988C10.1174 15.3662 10.5374 15.7862 10.5374 16.3037C10.5374 16.8212 10.1174 17.2412 9.59988 17.2412Z",
    fill: "#EC4E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9883 5.12549H13.1133C12.5958 5.12549 12.1758 4.70549 12.1758 4.18799C12.1758 3.67049 12.5958 3.25049 13.1133 3.25049H20.9883C21.5058 3.25049 21.9258 3.67049 21.9258 4.18799C21.9258 4.70549 21.5058 5.12549 20.9883 5.12549Z",
    fill: "#EC4E1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2914_1202",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 0.250488H8.53225V7.98999H0.75V0.250488Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2914_1202)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64125 2.125C3.53 2.125 2.625 3.02 2.625 4.12125C2.625 5.22125 3.53 6.115 4.64125 6.115C5.75375 6.115 6.6575 5.22125 6.6575 4.12125C6.6575 3.02 5.75375 2.125 4.64125 2.125ZM4.64125 7.99C2.49625 7.99 0.75 6.255 0.75 4.12125C0.75 1.9875 2.49625 0.25 4.64125 0.25C6.7875 0.25 8.5325 1.9875 8.5325 4.12125C8.5325 6.255 6.7875 7.99 4.64125 7.99Z",
    fill: "#EC4E1E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7343 14.2598C17.6218 14.2598 16.7168 15.1548 16.7168 16.2548C16.7168 17.356 17.6218 18.2498 18.7343 18.2498C19.8455 18.2498 20.7493 17.356 20.7493 16.2548C20.7493 15.1548 19.8455 14.2598 18.7343 14.2598ZM18.7343 20.1248C16.588 20.1248 14.8418 18.3885 14.8418 16.2548C14.8418 14.121 16.588 12.3848 18.7343 12.3848C20.8793 12.3848 22.6243 14.121 22.6243 16.2548C22.6243 18.3885 20.8793 20.1248 18.7343 20.1248Z",
    fill: "#EC4E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.9adf5633470fa781bdc42f7393cd8017.svg";
export { ForwardRef as ReactComponent };